import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetCameraTrapAttachmentsResponse } from "./type";

async function getCameraTrapAttachmentsById(
  cameraTrapId: string,
  query: GetQueries,
): Promise<GetCameraTrapAttachmentsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.devices.cameraTraps.getAttachments(cameraTrapId);
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetCameraTrapAttachmentsResponse>(url);

  return response.data;
}

export function useGetCameraTrapAttachments(
  cameraTrapId: string,
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [
      `fetch-camera-trap-attachments-${cameraTrapId}`,
      JSON.stringify(query ?? {}),
    ],
    () => getCameraTrapAttachmentsById(cameraTrapId, query ?? {}),
    mergedOptions,
  );
}
